var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirementLuxury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retirementLuxury-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(60 493.749)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retirementLuxury",
    transform: "translate(-60 -493.749)",
    clipPath: "url(#retirementLuxury-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.374,26.95a.709.709,0,0,0-.475-.3c-.994,0-9.554-.346-9.554-10.288a.562.562,0,1,0-1.124,0c0,9.943-8.559,10.288-9.51,10.288a.491.491,0,0,0-.346.13c-.086.043-.13.13-.173.173a.641.641,0,0,0,0,.562.6.6,0,0,0,.519.3h.043c.994,0,9.51.346,9.51,10.288a.562.562,0,1,0,1.124,0c0-9.9,8.516-10.288,9.51-10.288a.659.659,0,0,0,.519-.3A.531.531,0,0,0,48.374,26.95ZM37.783,33.866a9.867,9.867,0,0,0-6.744-6.657,9.867,9.867,0,0,0,6.744-6.657,9.867,9.867,0,0,0,6.744,6.657A9.867,9.867,0,0,0,37.783,33.866Z",
    transform: "translate(77.396 486.388)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.043,8.215a.582.582,0,0,0,.562-.605.572.572,0,0,0-.562-.562c-.519,0-5.187-.173-5.187-5.62a.562.562,0,0,0-1.124,0c0,5.447-4.669,5.62-5.187,5.62H10.5a.564.564,0,0,0-.519.562.572.572,0,0,0,.562.562c.562,0,5.187.173,5.187,5.62a.572.572,0,0,0,.562.562.5.5,0,0,0,.519-.519c0-5.447,4.669-5.62,5.187-5.62Zm-5.793,2.464A5.8,5.8,0,0,0,13.138,7.61a5.816,5.816,0,0,0,3.112-3.069A5.8,5.8,0,0,0,19.363,7.61,5.816,5.816,0,0,0,16.251,10.679Z",
    transform: "translate(86.003 493.883)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.061,46.2c-.519,0-5.187-.173-5.187-5.62a.562.562,0,1,0-1.124,0c0,5.447-4.669,5.62-5.187,5.62H.519A.564.564,0,0,0,0,46.759a.572.572,0,0,0,.562.562c.562,0,5.187.173,5.187,5.62a.572.572,0,0,0,.562.562c.259.086.519-.173.519-.519,0-5.447,4.669-5.62,5.187-5.62h.043a.583.583,0,0,0,.562-.605A.572.572,0,0,0,12.061,46.2ZM6.268,49.872A5.94,5.94,0,0,0,3.156,46.8a5.816,5.816,0,0,0,3.112-3.069A5.8,5.8,0,0,0,9.381,46.8,5.816,5.816,0,0,0,6.268,49.872Z",
    transform: "translate(91.014 474.23)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementLuxury);
export default __webpack_public_path__ + "static/media/retirementLuxury.3340970aa7a616e5cb360d0bec7954fa.svg";
export { ForwardRef as ReactComponent };